import type { Category } from "@/lib/types";

/**
 * ZH-TW Ingredient → Category Dictionary
 *
 * Contains ONLY singular base forms without quantities or containers.
 * Examples: "雞", "玉米", "沙拉醬" (not "兩隻雞", "一袋玉米", "一罐沙拉醬")
 *
 * The algorithm handles:
 * - Pluralization (beans → bean)
 * - Quantity stripping (2 lbs → removed)
 * - Container removal (jar of → removed)
 *
 * Converted from zh-CN dictionary + TW-specific entries.
 * Total entries: 3224
 */

export const zhTWDictionary: Record<string, Category> = {
  "8424西瓜": "fruit", // watermelon variety
  a菜: "produce",
  t骨牛排: "meat",
  xo醬: "other",
  一打雞蛋: "dairy",
  丁香: "other",
  七星椒: "produce",
  三华李: "fruit",
  三文魚: "seafood",
  三文魚片: "seafood",
  三明治: "other",
  三明治麵包: "other",
  三華李: "fruit",
  三角油豆腐: "other",
  三鮮肉餡: "meat",
  三鮮肉馅: "meat",
  三鮮餃子: "other",
  三黃雞: "meat",
  三黄雞: "meat",
  三點蟹: "seafood",
  上海青: "produce",
  不知火: "fruit",
  丑八怪: "fruit",
  丑橘: "fruit",
  东北酸菜: "other",
  东魁杨梅: "fruit",
  中卷: "seafood",
  中国南瓜: "produce",
  中国芹: "produce",
  中国茄子: "produce",
  中国黄瓜: "produce",
  中國南瓜: "produce",
  中國芹: "produce",
  中國茄子: "produce",
  中國黃瓜: "produce",
  中筋麵粉: "other",
  中蝦: "seafood",
  丰水梨: "fruit",
  丹麥麵包: "other",
  九孔鮑: "seafood",
  九层塔: "produce",
  九層塔: "produce",
  九節蝦: "seafood",
  九节蝦: "seafood",
  乳清: "dairy",
  乳清蛋白: "other",
  乳酪: "dairy",
  乳酸菌飲料: "other",
  乳酸菌饮料: "other",
  乳鴿: "meat",
  乳鴿蛋: "dairy",
  乾尧榴莲: "fruit",
  乾巴菌: "other",
  乾木耳: "other",
  乾松茸: "other",
  乾棗: "other",
  乾猴頭菇: "other",
  乾竹荪: "other",
  乾羊肚菌: "other",
  乾茶树菇: "other",
  乾蔥: "produce",
  乾豆角: "other",
  乾貝: "other",
  乾辣椒: "other",
  乾酪: "dairy",
  乾銀耳: "other",
  乾香菇: "other",
  乾黄花菜: "other",
  二荆條: "produce",
  二荊條: "produce",
  云南辣椒: "produce",
  云吞: "other",
  云盘蘑: "produce",
  云耳: "produce",
  五敛子: "fruit",
  五斂子: "fruit",
  五花肉: "meat",
  五香粉: "other",
  亚侧耳: "produce",
  亚側耳: "produce",
  亚麻籽: "other",
  亞側耳: "produce",
  亞麻籽: "other",
  人心果: "fruit",
  人造奶油: "other",
  人造黃油: "other",
  人造黄油: "other",
  仙人掌果: "fruit",
  伊丽莎白瓜: "fruit",
  伊麗莎白瓜: "fruit",
  优格: "dairy",
  低筋麵粉: "other",
  低糖酸奶: "dairy",
  低脂奶: "dairy",
  低脂牛奶: "dairy",
  余甘子: "fruit",
  佛利蒙柑: "fruit",
  佛手瓜: "produce",
  佛手瓜苗: "produce",
  佳沛奇异果: "fruit",
  佳沛奇異果: "fruit",
  侧耳: "produce",
  侧耳根: "produce",
  倭瓜: "produce",
  側耳: "produce",
  側耳根: "produce",
  储良龍眼: "fruit",
  優格: "dairy",
  儲良龍眼: "fruit",
  元蘑: "produce",
  元貝: "seafood",
  光盖菇: "produce",
  光蓋菇: "produce",
  光黃瓜: "produce",
  光黄瓜: "produce",
  克伦生葡萄: "fruit",
  克倫生葡萄: "fruit",
  兔子: "meat",
  兔肉: "meat",
  兔腿: "meat",
  內酯豆腐: "other",
  全脂奶: "dairy",
  全脂奶粉: "other",
  全脂牛奶: "dairy",
  全脂酸奶: "dairy",
  全麥粉: "other",
  全麥麵包: "other",
  八爪魚: "seafood",
  八角: "other",
  兰花菇: "produce",
  内酯豆腐: "other",
  冬棗: "fruit",
  冬瓜: "produce",
  冬瓜苗: "produce",
  冬筍: "produce",
  冬粉: "other",
  冬菇: "produce",
  冬菜: "other",
  冰凍蝦仁: "seafood",
  冰李: "fruit",
  冰棍: "other",
  冰淇淋: "other",
  冰激凌: "other",
  冰烤地瓜: "other",
  冰糖: "other",
  冰糖心蘋果: "fruit",
  冰糖橙: "fruit",
  冰菜: "produce",
  冰蝦: "seafood",
  冷凍扇貝: "other",
  冷凍毛豆: "other",
  冷凍海鮮: "other",
  冷凍混合蔬菜: "other",
  冷凍牛肉: "other",
  冷凍玉米: "other",
  冷凍章魚: "other",
  冷凍羊肉: "other",
  冷凍肉类: "other",
  冷凍肉類: "other",
  冷凍胡蘿蔔: "other",
  冷凍花菜: "other",
  冷凍蔬菜: "other",
  冷凍蝦仁: "other",
  冷凍西兰花: "other",
  冷凍西蘭花: "other",
  冷凍豌豆: "other",
  冷凍豬肉: "other",
  冷凍雞肉: "other",
  冷凍青豆: "other",
  冷凍餃子: "other",
  冷凍魚: "other",
  冷凍魷魚: "other",
  凉瓜: "produce",
  凍蝦: "seafood",
  凍豆腐: "other",
  凝固型酸奶: "dairy",
  凯撒醬: "other",
  凯特芒: "fruit",
  凱撒醬: "other",
  凱特芒: "fruit",
  刀削麵: "other",
  刀豆: "produce",
  刁草: "produce",
  分蔥: "produce",
  切达奶酪: "dairy",
  切達奶酪: "dairy",
  初榨橄榄油: "other",
  初榨橄欖油: "other",
  初生蛋: "dairy",
  刨碎奶酪: "dairy",
  利馬豆: "other",
  利马豆: "other",
  刺嫩芽: "produce",
  刺梨: "fruit",
  刺老芽: "produce",
  刺黃瓜: "produce",
  刺黄瓜: "produce",
  刺龍芽: "produce",
  剁椒: "other",
  前腿肉: "meat",
  剪脚香菇: "produce",
  剪腳香菇: "produce",
  劍蝦: "seafood",
  功能飲料: "other",
  功能饮料: "other",
  加州西梅: "fruit",
  加拿大車釐子: "fruit",
  加拿大车釐子: "fruit",
  加拿大龍蝦: "seafood",
  包子: "other",
  包心菜: "produce",
  包脚菇: "produce",
  包腳菇: "produce",
  包菜: "produce",
  北京烤鴨: "other",
  北极甜蝦: "seafood",
  北极蝦: "seafood",
  北极貝: "seafood",
  北極甜蝦: "seafood",
  北極蝦: "seafood",
  北極貝: "seafood",
  北豆腐: "other",
  北風菌: "produce",
  北风菌: "produce",
  十三香: "other",
  千岛醬: "other",
  千島醬: "other",
  千禧果: "produce",
  千禧番茄: "produce",
  午仔魚: "seafood",
  午餐肉: "other",
  华夫餅: "other",
  单环刺螠: "seafood",
  南华菇: "produce",
  南姜: "produce",
  南瓜: "produce",
  南瓜子: "other",
  南瓜花: "produce",
  南瓜苗: "produce",
  南美白对蝦: "seafood",
  南美白對蝦: "seafood",
  南美白蝦: "seafood",
  南華菇: "produce",
  南薑: "produce",
  南豆腐: "other",
  卡門貝爾奶酪: "dairy",
  卡门貝尔奶酪: "dairy",
  印度棗: "fruit",
  即食燕麥: "other",
  卷葉歐芹: "produce",
  厄瓜多尔白蝦: "seafood",
  厄瓜多爾白蝦: "seafood",
  厚菇: "produce",
  原味酸奶: "dairy",
  叉燒: "meat",
  叉燒肉: "other",
  叉燒醬: "other",
  双孢菇: "produce",
  双孢蘑菇: "produce",
  变蛋: "other",
  口水雞: "other",
  口蘑: "produce",
  口香糖: "other",
  叫花雞: "other",
  可乐: "other",
  可樂: "other",
  可頌: "other",
  可颂: "other",
  台湾木瓜: "fruit",
  台湾青棗: "fruit",
  台湾鳳梨: "fruit",
  台農57號: "produce",
  合掌瓜: "produce",
  吉拉多生蠔: "seafood",
  吊菜子: "produce",
  后腿肉: "meat",
  吐司: "other",
  吞拿魚: "seafood",
  吞拿魚罐頭: "other",
  味精: "other",
  味噌: "other", // miso paste
  味噌醬: "other", // miso paste
  咖啡: "other",
  咖啡粉: "other",
  咖啡豆: "other",
  咖喱: "other",
  咖喱塊: "other",
  咖喱粉: "other",
  咖喱膏: "other",
  哈密瓜: "fruit",
  哈斯牛油果: "fruit",
  响螺: "seafood",
  啡蘑菇: "produce",
  啤梨: "fruit",
  單環刺螠: "seafood",
  喷射奶油: "dairy",
  嘉鱲: "seafood",
  嘎啦蘋果: "fruit",
  噴射奶油: "dairy",
  四季橘: "fruit",
  四季豆: "produce",
  四季豆苗: "produce",
  四川泡菜: "other",
  四川辣椒: "produce",
  四棱豆: "produce",
  四稜豆: "produce",
  国光蘋果: "fruit",
  圆椒: "produce",
  圆白菜: "produce",
  圆茄子: "produce",
  國光蘋果: "fruit",
  圓椒: "produce",
  圓白菜: "produce",
  圓茄子: "produce",
  土芒果: "fruit",
  土芭樂: "fruit",
  土豆: "produce",
  土雞: "meat",
  土雞蛋: "dairy",
  圣代: "other",
  圣女果: "produce",
  地瓜: "produce",
  地瓜葉: "produce",
  地黃瓜: "produce",
  地黄瓜: "produce",
  坚果: "other",
  培根: "meat",
  基围蝦: "seafood",
  基圍蝦: "seafood",
  堅果: "other",
  塗抹奶酪: "dairy",
  塘鯴: "seafood",
  塘鲺: "seafood",
  墨斗魚: "seafood",
  墨西哥牛油果: "fruit",
  墨西哥辣椒: "produce",
  墨魚: "seafood",
  墨魚丸: "other",
  墨魚乾: "seafood",
  墨魚仔: "seafood",
  壺底油: "other",
  壽司米: "other",
  夏威夷木瓜: "fruit",
  夏威夷果: "other",
  夏菇: "produce",
  夏黑葡萄: "fruit",
  多宝魚: "seafood",
  多寶魚: "seafood",
  大冬瓜: "produce",
  大台芒: "fruit",
  大料: "other",
  大棚番茄: "produce",
  大棚茄子: "produce",
  大棚黃瓜: "produce",
  大棚黄瓜: "produce",
  大溪豆干: "other",
  大牛心: "produce",
  大球盖菇: "produce",
  大球菌: "produce",
  大球蓋菇: "produce",
  大甲芋頭: "produce",
  大番茄: "produce",
  大白菜: "produce",
  大米: "other",
  大紅番茄: "produce",
  大臺芒: "fruit",
  大芥菜: "produce",
  大苦瓜: "produce",
  大茴香: "other",
  大葉菠菜: "produce",
  大葉香菜: "produce",
  大蒜: "produce",
  大蔥: "produce",
  大蔥頭: "produce",
  大蕉: "fruit",
  大蘑菇: "produce",
  大蝦: "seafood",
  大西洋鮭: "seafood",
  大豆: "other",
  大豆油: "other",
  大閘蟹: "seafood",
  大闸蟹: "seafood",
  大陸妹: "produce",
  大青棗: "fruit",
  大青椒: "produce",
  大黃魚: "seafood",
  大黄魚: "seafood",
  太平洋生蠔: "seafood",
  太平洋鮭: "seafood",
  太空包香菇: "produce",
  夹心餅乾: "other",
  夾心餅乾: "other",
  奇亚籽: "other",
  奇亞籽: "other",
  奇异果: "fruit",
  奇異果: "fruit",
  奶: "dairy",
  奶油: "dairy",
  奶油南瓜: "produce",
  奶油奶酪: "dairy",
  奶油生菜: "produce",
  奶油白菜: "produce",
  奶油芝士: "dairy",
  奶油草莓: "fruit",
  奶油蛋糕: "other",
  奶油麵包: "other",
  奶白菜: "produce",
  奶粉: "other",
  奶茶: "other",
  奶酪: "dairy",
  奶酪塊: "dairy",
  奶酪條: "dairy",
  奶酪片: "dairy",
  奶酪絲: "dairy",
  如意菜: "produce",
  妃子笑荔枝: "fruit",
  姑娘果: "fruit",
  姜: "produce",
  姜塊: "produce",
  姬松茸: "produce",
  威化: "other",
  威化餅: "other",
  娃娃菜: "produce",
  婴儿奶粉: "other",
  嫩南瓜: "produce",
  嫩姜: "produce",
  嫩玉米: "produce",
  嫩瓜: "produce",
  嫩茄子: "produce",
  嫩薑: "produce",
  嫩蚕豆: "produce",
  嫩蠶豆: "produce",
  嫩豆腐: "other",
  嫩豆角: "produce",
  嫩豌豆: "produce",
  嫩黃瓜: "produce",
  嫩黄瓜: "produce",
  嬰兒奶粉: "other",
  子姜: "produce",
  子弹頭: "produce",
  子彈頭: "produce",
  子薑: "produce",
  孜然: "other",
  孜然粉: "other",
  孜然粒: "other",
  宁波年糕: "other",
  安康魚: "seafood",
  宝塔花菜: "produce",
  客家板條: "other",
  宣木瓜: "fruit",
  密刺黃瓜: "produce",
  密刺黄瓜: "produce",
  富士蘋果: "fruit",
  富平柿子: "fruit",
  寧波年糕: "other",
  寬粉: "other",
  寬豆角: "produce",
  寶塔花菜: "produce",
  对蝦: "seafood",
  寿司米: "other",
  對蝦: "seafood",
  小冬瓜: "produce",
  小卷: "seafood",
  小台芒: "fruit",
  小土豆: "produce",
  小墨魚: "seafood",
  小方干: "other",
  小瓜: "produce",
  小甘蓝: "produce",
  小甘藍: "produce",
  小番茄: "produce",
  小白菜: "produce",
  小章魚: "seafood",
  小笼包: "other",
  小籠包: "other",
  小米: "other",
  小米椒: "produce",
  小米辣: "produce",
  小紅莓: "fruit",
  小臺芒: "fruit",
  小芋頭: "produce",
  小芥菜: "produce",
  小苦瓜: "produce",
  小茴香: "produce",
  小菠菜: "produce",
  小葉香菜: "produce",
  小蔥: "produce",
  小蘑菇: "produce",
  小蝦: "seafood",
  小西瓜: "fruit",
  小西紅柿: "fruit",
  小豆苗: "produce",
  小鮑魚: "seafood",
  小麥芽: "produce",
  小黃瓜: "produce",
  小黃魚: "seafood",
  小黄瓜: "produce",
  小黄魚: "seafood",
  小龍蝦: "seafood",
  尖塔花菜: "produce",
  尖椒: "produce",
  尤力克檸檬: "fruit",
  山椒: "other",
  山楂: "fruit",
  山楂醬: "other",
  山竹: "fruit",
  山羊奶酪: "dairy",
  山芋: "produce",
  山茼蒿: "produce",
  山药: "produce",
  山药蛋: "produce",
  山药豆: "produce",
  山葵: "other",
  山藥: "produce",
  山藥蛋: "produce",
  山藥豆: "produce",
  山蘇: "produce",
  岩鹽: "other",
  岩龍蝦: "seafood",
  崑崙瓜: "produce",
  巖龍蝦: "seafood",
  工研醋: "other",
  巧克力: "other",
  巧克力草莓: "fruit",
  巨峰葡萄: "fruit",
  巴氏杀菌奶: "dairy",
  巴氏殺菌奶: "dairy",
  巴沙魚: "seafood",
  布丁: "other",
  布里奶酪: "dairy",
  希臘酸奶: "dairy",
  帕尔马乾酪: "dairy",
  帕爾馬乾酪: "dairy",
  帕玛森芝士: "dairy",
  帕瑪森芝士: "dairy",
  帝王柑: "fruit",
  帝王蟹: "seafood",
  帶子: "seafood",
  帶花黃瓜: "produce",
  帶花黄瓜: "produce",
  帶魚: "seafood",
  平菇: "produce",
  平葉欧芹: "produce",
  平葉歐芹: "produce",
  年糕: "other",
  幹堯榴蓮: "fruit",
  幹木耳: "other",
  幹松茸: "other",
  幹棗: "other",
  幹猴頭菇: "other",
  幹竹蓀: "other",
  幹羊肚菌: "other",
  幹茶樹菇: "other",
  幹蔥: "produce",
  幹豆角: "other",
  幹辣椒: "other",
  幹銀耳: "other",
  幹香菇: "other",
  幹黃花菜: "other",
  库尔勒香梨: "fruit",
  庫爾勒香梨: "fruit",
  开心果: "other",
  彩椒: "produce",
  後腿肉: "meat",
  徐香猕猴桃: "fruit",
  徐香獼猴桃: "fruit",
  心裡美: "produce",
  心裡美蘿蔔: "produce",
  心里美: "produce",
  心里美蘿蔔: "produce",
  快煮麵: "other",
  恐龍蛋: "fruit",
  意大利欧芹: "produce",
  意大利歐芹: "produce",
  意大利西葫蘆: "produce",
  意大利香菜: "produce",
  意大利醋: "other", // balsamic vinegar
  意大利黑醋: "other", // balsamic vinegar
  意大利麵: "other",
  義大利麵: "other",
  義大利醋: "other", // balsamic vinegar (Traditional)
  義大利黑醋: "other", // balsamic vinegar (Traditional)
  意粉: "other",
  意麵: "other",
  愛媛: "fruit",
  愛媛38號: "fruit",
  愛文芒果: "fruit",
  慈姑: "produce",
  慕斯蛋糕: "other",
  成人奶粉: "other",
  扁桃仁: "other",
  扁豆: "produce",
  扁豆苗: "produce",
  扇貝: "seafood",
  扇貝肉: "seafood",
  手瓜: "produce",
  打發奶油: "dairy",
  托曼尼榴莲: "fruit",
  抄手: "other",
  折耳根: "produce",
  披萨: "other",
  披薩: "other",
  抱子甘蓝: "produce",
  抱子甘藍: "produce",
  拉麵: "other",
  挂麵: "other",
  指天椒: "produce",
  挪威三文魚: "seafood",
  捲心菜: "produce",
  捲葉欧芹: "produce",
  掐菜: "produce",
  排骨: "meat",
  排骨醬: "other",
  掛麵: "other",
  提子: "fruit",
  提子乾: "other",
  提拉米苏: "other",
  提拉米蘇: "other",
  搅打奶油: "dairy",
  搅拌型酸奶: "dairy",
  搅瓜: "produce",
  撇蓝: "produce",
  撇藍: "produce",
  攪打奶油: "dairy",
  攪拌型酸奶: "dairy",
  攪瓜: "produce",
  散葉生菜: "produce",
  文旦: "fruit",
  文蛤: "seafood",
  斑節蝦: "seafood",
  斑节蝦: "seafood",
  料酒: "other",
  紹興酒: "other", // shaoxing wine
  紹興黃酒: "other", // shaoxing yellow wine
  紹興料酒: "other", // shaoxing cooking wine
  新土豆: "produce",
  新奇士橙: "fruit",
  新疆哈密瓜: "fruit",
  新疆辣椒: "produce",
  新竹米粉: "other",
  新蒜: "produce",
  新鮮无花果: "fruit",
  新鮮無花果: "fruit",
  新鮮牛奶: "dairy",
  新鮮芡实: "produce",
  新鮮芡實: "produce",
  新鮮莲子: "produce",
  新鮮菠菜: "produce",
  新鮮蓮子: "produce",
  新鮮香菇: "produce",
  方便麵: "other",
  方形西瓜: "fruit",
  方椒: "produce",
  方糖: "other",
  旗魚: "seafood",
  旗魚丸: "other",
  旗魚肚: "seafood",
  无刺黄瓜: "produce",
  无籽西瓜: "fruit",
  无籽黑提: "fruit",
  无糖酸奶: "dairy",
  无花果: "fruit",
  无花果乾: "other",
  无菌蛋: "dairy",
  无鹽黄油: "dairy",
  日本南瓜: "produce",
  日本茄子: "produce",
  日本豆腐: "other",
  日本黃瓜: "produce",
  日本黄瓜: "produce",
  旱黃瓜: "produce",
  旱黄瓜: "produce",
  时蘿: "produce",
  昆仑瓜: "produce",
  昆布: "other",
  明太魚: "seafood",
  明蝦: "seafood",
  星果: "fruit",
  春筍: "produce",
  春菇: "produce",
  春菊: "produce",
  春見: "fruit",
  春见: "fruit",
  時蘿: "produce",
  是拉差: "other", // sriracha sauce (transliteration)
  是拉差辣椒醬: "other", // sriracha hot sauce
  普洱茶: "other",
  智利三文魚: "seafood",
  智利車釐子: "fruit",
  智利车釐子: "fruit",
  曲奇: "other",
  曲奇餅: "other",
  月桂葉: "other",
  月餅: "other",
  有机牛奶: "dairy",
  有机番茄: "produce",
  有机花菜: "produce",
  有机茄子: "produce",
  有机草莓: "fruit",
  有机蔬菜: "produce",
  有机西兰花: "produce",
  有机豆芽: "produce",
  有机雞蛋: "dairy",
  有机香菇: "produce",
  有机黄瓜: "produce",
  有機牛奶: "dairy",
  有機番茄: "produce",
  有機花菜: "produce",
  有機茄子: "produce",
  有機草莓: "fruit",
  有機蔬菜: "produce",
  有機西蘭花: "produce",
  有機豆芽: "produce",
  有機雞蛋: "dairy",
  有機香菇: "produce",
  有機黃瓜: "produce",
  有籽西瓜: "fruit",
  有鹽黃油: "dairy",
  有鹽黄油: "dairy",
  朝天椒: "produce",
  木瓜: "fruit",
  木耳: "produce",
  木耳菜: "produce",
  木耳菜葉: "produce",
  木薯: "produce",
  杂色蛤: "seafood",
  杂菜: "produce",
  李子: "fruit",
  杏: "fruit",
  杏乾: "other",
  杏仁: "other",
  杏仁奶: "other",
  杏子: "fruit",
  杏幹: "other",
  杏醬: "other",
  杏鮑菇: "produce",
  杨桃: "fruit",
  杨桃豆: "produce",
  杨梅: "fruit",
  杭椒: "produce",
  東北酸菜: "other",
  東魁楊梅: "fruit",
  松乳菇: "produce",
  松子: "other",
  松花蛋: "other",
  松茸: "produce",
  松露: "produce",
  松餅: "other",
  板栗: "other",
  板栗南瓜: "produce",
  板條: "other",
  板豆腐: "other",
  板鴨: "other",
  枇杷: "fruit",
  果凍: "other",
  果桑: "fruit",
  果汁: "other",
  果醬: "other",
  枝豆: "produce",
  枫糖: "other",
  枫糖浆: "other",
  架豆: "produce",
  架黃瓜: "produce",
  架黄瓜: "produce",
  柑: "fruit",
  柑橘: "fruit",
  柚子: "fruit",
  柱候醬: "other",
  柳松菇: "produce",
  柳橙: "fruit",
  柳芽: "produce",
  柴雞蛋: "dairy",
  柿子: "fruit",
  柿子乾: "other",
  柿子幹: "other",
  柿子椒: "produce",
  柿餅: "other",
  树莓: "fruit",
  栗子: "other",
  栗子地瓜: "produce",
  核桃: "other",
  核桃仁: "other",
  核桃奶: "other",
  桂味荔枝: "fruit",
  桂圆: "fruit",
  桂圆乾: "other",
  桂圓: "fruit",
  桂圓乾: "other",
  桂林米粉: "other",
  桂皮: "other",
  桂葉: "other",
  桂魚: "seafood",
  桃: "fruit",
  桃子: "fruit",
  桃李: "fruit",
  桃酥: "other",
  桃醬: "other",
  桑果: "fruit",
  桑葚: "fruit",
  桔子: "fruit",
  桶柑: "fruit",
  梅: "fruit",
  梅乾菜: "other",
  梅花肉: "meat",
  梅頭肉: "meat",
  梨: "fruit",
  梨子: "fruit",
  梭子蟹: "seafood",
  棒棒糖: "other",
  棕蘑菇: "produce",
  棗: "fruit",
  植物奶油: "other",
  植物油: "other",
  植物黃油: "other",
  植物黄油: "other",
  椪柑: "fruit",
  椰奶: "other",
  椰子: "fruit",
  椰子油: "other",
  椰棗: "fruit",
  椰汁: "other",
  椰浆: "other",
  椰漿: "other",
  椰皇: "fruit",
  椰肉: "fruit",
  椰蓉: "other",
  椰蓉麵包: "other",
  椰青: "fruit",
  椴木香菇: "produce",
  椿芽: "produce",
  楊桃: "fruit",
  酸楊桃: "fruit",
  楊桃豆: "produce",
  楊梅: "fruit",
  楓糖: "other",
  楓糖漿: "other",
  榆耳: "produce",
  榆錢: "produce",
  榆钱: "produce",
  榆黃蘑: "produce",
  榆黄蘑: "produce",
  榛子: "other",
  榨菜: "other",
  榴莲: "fruit",
  榴莲乾: "other",
  榴莲肉: "fruit",
  榴蓮: "fruit",
  榴蓮幹: "other",
  榴蓮肉: "fruit",
  槐花: "produce",
  槟榔芋: "produce",
  樹莓: "fruit",
  樹薯: "produce",
  橄榄油: "other",
  橄欖油: "other",
  橘子: "fruit",
  橙: "fruit",
  橙圣女果: "produce",
  橙子: "fruit",
  橙椒: "produce",
  橙汁: "other",
  橙片: "fruit",
  橙番茄: "produce",
  橙皮醬: "other",
  橙聖女果: "fruit",
  檳榔心芋: "produce",
  檳榔芋: "produce",
  檸檬: "fruit",
  檸檬水: "other",
  檸檬汁: "other",
  檸檬片: "fruit",
  檸檬百香果: "fruit",
  檸檬罗勒: "produce",
  檸檬羅勒: "produce",
  檸檬草: "produce",
  檸檬薄荷: "produce",
  檸檬醬: "other",
  櫻桃: "fruit",
  櫻桃番茄: "produce",
  櫻桃蘿蔔: "produce",
  櫻花蝦: "seafood",
  欧芹: "produce",
  歐芹: "produce",
  武昌魚: "seafood",
  段木香菇: "produce",
  比目魚: "seafood",
  比萨: "other",
  比薩: "other",
  毛桃: "fruit",
  毛毛蟲麵包: "other",
  毛瓜: "produce",
  毛筍: "produce",
  毛節瓜: "produce",
  毛节瓜: "produce",
  毛芋: "produce",
  毛芋頭: "produce",
  毛荔枝: "fruit",
  毛蚶: "seafood",
  毛蟹: "seafood",
  毛豆: "produce",
  毛豆腐: "other",
  水山药: "produce",
  水山藥: "produce",
  水晶梨: "fruit",
  水晶菜: "produce",
  水晶葡萄: "fruit",
  水果玉米: "produce",
  水果番茄: "fruit",
  水果酸奶: "dairy",
  水果黃瓜: "produce",
  水果黄瓜: "produce",
  水煮毛豆: "other",
  水煮蛋: "other",
  水瓜: "produce",
  水田芥: "produce",
  水芹: "produce",
  水芹菜: "produce",
  水蘿蔔: "produce",
  水蜜桃: "fruit",
  水蜜桃罐頭: "other",
  水餃: "other",
  水魚: "seafood",
  水黃瓜: "produce",
  水黄瓜: "produce",
  汉堡: "other",
  汉堡包: "other",
  江米: "other",
  汽水: "other",
  沃柑: "fruit",
  沙丁魚: "seafood",
  沙公: "seafood",
  沙姜: "produce",
  沙拉醬: "other",
  沙棘: "fruit",
  沙母: "seafood",
  沙瓤番茄: "produce",
  沙田柚: "fruit",
  沙茶醬: "other",
  沙薑: "produce",
  沙蝦: "seafood",
  河粉: "other",
  河蚌: "seafood",
  河蝦: "seafood",
  河蟹: "seafood",
  河豚: "seafood",
  河鰻: "seafood",
  油: "other",
  油桃: "fruit",
  油條: "other",
  油甘: "fruit",
  油茶菇: "produce",
  油菜: "produce",
  油豆腐: "other",
  油豆角: "produce",
  油醋汁: "other",
  油魚: "seafood",
  油麥: "produce",
  油麥菜: "produce",
  油麵: "other",
  法国生蠔: "seafood",
  法國生蠔: "seafood",
  法棍: "other",
  泡椒: "other",
  泡泡糖: "other",
  泡發木耳: "produce",
  泡發銀耳: "produce",
  泡芙: "other",
  泡菜: "other",
  泡麵: "other",
  波士頓龍蝦: "seafood",
  波士顿龍蝦: "seafood",
  波特菇: "produce",
  波龍: "seafood",
  泥蚶: "seafood",
  泥鰍: "seafood",
  泥鳅: "seafood",
  泰国罗勒: "produce",
  泰國羅勒: "produce",
  泰椒: "produce",
  洁净蛋: "dairy",
  洋姜: "produce",
  洋柿子: "produce",
  洋瓜: "produce",
  洋白菜: "produce",
  洋芋: "produce",
  洋蒲桃: "fruit",
  洋蔥: "produce",
  洋蔥丁: "produce",
  洋蔥圈: "produce",
  洋蔥塊: "produce",
  洋蔥絲: "produce",
  洋蔥頭: "produce",
  洋薑: "produce",
  洋蘑菇: "produce",
  活蝦: "seafood",
  浓奶油: "dairy",
  海参: "seafood",
  海參: "seafood",
  海山醬: "other",
  海帶片: "produce",
  海帶結: "produce",
  海帶絲: "produce",
  海帶结: "produce",
  海星: "seafood",
  海梨柑: "fruit",
  海沃德猕猴桃: "fruit",
  海沃德獼猴桃: "fruit",
  海瓜子: "seafood",
  海白菜: "produce",
  海肠: "seafood",
  海肠子: "seafood",
  海胆: "seafood",
  海胆黄: "seafood",
  海腸: "seafood",
  海腸子: "seafood",
  海膽: "seafood",
  海膽黃: "seafood",
  海苔: "other",
  海葵: "seafood",
  海虹: "seafood",
  海蛎: "seafood",
  海蛎子: "seafood",
  海蜇: "seafood",
  海蜇皮: "seafood",
  海蜇頭: "seafood",
  海蝦: "seafood",
  海螺: "seafood",
  海螺肉: "seafood",
  海蟹: "seafood",
  海蠣: "seafood",
  海蠣子: "seafood",
  海鮮菇: "produce",
  海鮮醬: "other",
  海鯛: "seafood",
  海鰻: "seafood",
  海鱸魚: "seafood",
  海鹽: "other",
  涂抹奶酪: "dairy",
  消化餅: "other",
  涩柿: "fruit",
  涼瓜: "produce",
  淡奶油: "dairy",
  淡水蝦: "seafood",
  淡水鱸魚: "seafood",
  淡水龍蝦: "seafood",
  九孔: "seafood",
  七星鱸: "seafood",
  紅目鰱: "seafood",
  金目鱸: "seafood",
  紅斑: "seafood",
  台灣鯛: "seafood",
  烏鰡: "seafood",
  淡炼乳: "dairy",
  淡煉乳: "dairy",
  淡菜: "seafood",
  淮山: "produce",
  混合坚果: "other",
  混合堅果: "other",
  混合蔬菜: "produce",
  清汤火锅底料: "other",
  清湯火鍋底料: "other",
  温室番茄: "produce",
  温室茄子: "produce",
  温室黄瓜: "produce",
  温泉蛋: "other",
  湖南辣椒: "produce",
  溏心蛋: "other",
  溫室番茄: "produce",
  溫室茄子: "produce",
  溫室黃瓜: "produce",
  溫泉蛋: "other",
  滑子菇: "produce",
  滑菇: "produce",
  滷牛肉: "other",
  滷肉: "other",
  滷蛋: "other",
  滷豬蹄: "other",
  滷雞: "other",
  滷鴨: "other",
  漢堡: "other",
  漢堡包: "other",
  潔淨蛋: "dairy",
  澀柿: "fruit",
  澳洲青苹: "fruit",
  澳洲青蘋: "fruit",
  澳洲龍蝦: "seafood",
  澳芒: "fruit",
  澳龍: "seafood",
  濃奶油: "dairy",
  濑尿蝦: "seafood",
  瀨尿蝦: "seafood",
  灌汤包: "other",
  灌湯包: "other",
  火晶柿子: "fruit",
  火箭菜: "produce",
  火腿: "meat",
  火腿肠: "other",
  火腿腸: "other",
  火蔥: "produce",
  火鍋底料: "other",
  火锅底料: "other",
  火雞: "meat",
  火雞肉: "meat",
  火雞胸: "meat",
  火龍果: "fruit",
  灯笼果: "fruit",
  灯笼椒: "produce",
  灯笼茄: "produce",
  灰菜: "produce",
  炊粉: "other",
  炸豆包: "other",
  炸雞: "other",
  炸雞翅: "other",
  炸雞腿: "other",
  炼乳: "dairy",
  烏冬麵: "other",
  烏梅: "other",
  烏賊: "seafood",
  烏贼: "seafood",
  烏醋: "other",
  烏雞: "meat",
  烏魚: "seafood",
  烏魚子: "other",
  烏龍茶: "other",
  烏龍麵: "other",
  烟台蘋果: "fruit",
  烤肉醬: "other",
  烤肠: "other",
  烤腸: "other",
  烤雞: "other",
  烤鴨: "other",
  热狗: "other",
  热狗麵包: "other",
  無刺黃瓜: "produce",
  無籽檸檬: "fruit",
  無籽西瓜: "fruit",
  無籽黑提: "fruit",
  無糖酸奶: "dairy",
  無花果: "fruit",
  無花果乾: "other",
  無菌蛋: "dairy",
  無鹽黃油: "dairy",
  煉乳: "dairy",
  煎餃: "other",
  煙臺蘋果: "fruit",
  熟花生: "other",
  熱狗: "other",
  熱狗麵包: "other",
  燈籠果: "fruit",
  燈籠椒: "produce",
  燈籠茄: "produce",
  燒卖: "other",
  燒賣: "other",
  燒雞: "other",
  燒鵝: "other",
  燒麥: "other",
  燕麥: "other",
  燕麥奶: "other",
  燕麥片: "other",
  爆米花: "other",
  爱媛: "fruit",
  爱媛38号: "fruit",
  牛: "meat",
  牛上脑: "meat",
  牛上腦: "meat",
  牛仔骨: "meat",
  牛前腱: "meat",
  牛后腱: "meat",
  牛外脊: "meat",
  牛奶: "dairy",
  牛奶棗: "fruit",
  牛奶草莓: "fruit",
  牛小排: "meat",
  牛尾: "meat",
  牛後腱: "meat",
  牛心: "meat",
  牛心番茄: "produce",
  牛排: "meat",
  牛排番茄: "produce",
  牛柳: "meat",
  牛毛肚: "meat",
  牛油: "dairy",
  牛油果: "fruit",
  牛油果油: "other",
  牛油果醬: "other",
  牛番茄: "produce",
  牛百葉: "meat",
  牛筋: "meat",
  牛肉: "meat",
  牛肉塊: "meat",
  牛肉洋蔥餡: "meat",
  牛肉洋蔥馅: "meat",
  牛肉片: "meat",
  牛肉番茄: "produce",
  牛肉粒: "meat",
  牛肉絲: "meat",
  牛肉餡: "meat",
  牛肉馅: "meat",
  牛肋條: "meat",
  牛肚: "meat",
  牛肝: "meat",
  牛肝菌: "produce",
  牛肩肉: "meat",
  牛肺: "meat",
  牛肾: "meat",
  牛胸肉: "meat",
  牛脑: "meat",
  牛腎: "meat",
  牛腦: "meat",
  牛腩: "meat",
  牛腩塊: "meat",
  牛腰子: "meat",
  牛腰肉: "meat",
  牛腱: "meat",
  牛腱子: "meat",
  牛腱肉: "meat",
  牛至: "produce",
  牛舌: "meat",
  牛蒡: "produce",
  牛蒡根: "produce",
  牛蛙: "meat",
  牛血: "meat",
  牛裡脊: "meat",
  牛角包: "other",
  牛角椒: "produce",
  牛蹄: "meat",
  牛蹄筋: "meat",
  牛里脊: "meat",
  牛霖: "meat",
  牛鞭: "meat",
  牛頭牌沙茶醬: "other",
  牛頸肉: "meat",
  牛颈肉: "meat",
  牛骨: "meat",
  牡丹蝦: "seafood",
  牡蛎: "seafood",
  牡蠣: "seafood",
  独蒜: "produce",
  独頭蒜: "produce",
  狭鱈魚: "seafood",
  狹鱈魚: "seafood",
  猕猴桃: "fruit",
  猫山王榴莲: "fruit",
  猴頭菇: "produce",
  獨蒜: "produce",
  獨頭蒜: "produce",
  獼猴桃: "fruit",
  玉文芒果: "fruit",
  玉米: "produce",
  玉米棒: "produce",
  玉米段: "produce",
  玉米油: "other",
  玉米筍: "produce",
  玉米粉: "other",
  玉米粒: "produce",
  玉米粒罐頭: "other",
  玉米须: "produce",
  玉米鬚: "produce",
  玉米麵: "other",
  玉蔓菁: "produce",
  玉蕈: "produce",
  王八: "seafood",
  王子麵: "other",
  玫瑰香葡萄: "fruit",
  玻璃生菜: "produce",
  珊瑚菇: "produce",
  珍宝蟹: "seafood",
  珍寶蟹: "seafood",
  珍珠奶茶: "other",
  珍珠洋蔥: "produce",
  珍珠番茄: "fruit",
  珍珠米: "other",
  珍珠芭樂: "fruit",
  珍珠菇: "produce",
  球生菜: "produce",
  球芽甘蓝: "produce",
  球芽甘藍: "produce",
  球莖甘蓝: "produce",
  球莖甘藍: "produce",
  琯溪蜜柚: "fruit",
  琵琶腿: "meat",
  琵琶蝦: "seafood",
  瑞士奶酪: "dairy",
  瑞士捲: "other",
  瓜子: "other",
  瓠子: "produce",
  瓠瓜: "produce",
  甘田醬油: "other",
  甘蓝: "produce",
  甘薯: "produce",
  甘藍: "produce",
  甜查理草莓: "fruit",
  甜柿: "fruit",
  甜椒: "produce",
  甜椒苗: "produce",
  甜洋蔥: "produce",
  甜炼乳: "dairy",
  甜煉乳: "dairy",
  甜玉米: "produce",
  甜瓜: "fruit",
  甜筒: "other",
  甜罗勒: "produce",
  甜羅勒: "produce",
  甜菜: "produce",
  甜菜根: "produce",
  甜蝦: "seafood",
  甜豆: "produce",
  甜豆角: "produce",
  甜辣醬: "other",
  甜麵醬: "other",
  生抽: "other",
  生日蛋糕: "other",
  生煎包: "other",
  生花生: "other",
  生菜: "produce",
  生薑: "produce",
  生蠔: "seafood",
  生豆包: "other",
  生魚: "seafood",
  田螺: "seafood",
  田雞: "meat",
  甲仑榴莲: "fruit",
  甲侖榴蓮: "fruit",
  甲魚: "seafood",
  留兰香: "produce",
  留蘭香: "produce",
  番木瓜: "fruit",
  番瓜: "produce",
  番石榴: "fruit",
  番茄: "produce",
  番茄沙司: "other",
  番茄秧: "produce",
  番茄苗: "produce",
  番茄醬: "other",
  番荔枝: "fruit",
  番薯: "produce",
  番薯葉: "produce",
  癞瓜: "produce",
  癩瓜: "produce",
  發芽豆: "produce",
  發酵乳: "dairy",
  發酵黃油: "dairy",
  發酵黄油: "dairy",
  白乾: "other",
  白兰瓜: "fruit",
  白冬瓜: "produce",
  白加仑: "fruit",
  白加侖: "fruit",
  白帶魚: "seafood",
  白心柚: "fruit",
  白心火龍果: "fruit",
  白心蘿蔔: "produce",
  白斩雞: "other",
  白斬雞: "other",
  白木耳: "produce",
  白杨梅: "fruit",
  白松露: "produce",
  白枇杷: "fruit",
  白桃: "fruit",
  白桑葚: "fruit",
  白條魚: "seafood",
  白椒: "produce",
  白楊梅: "fruit",
  白殼雞蛋: "dairy",
  白洋蔥: "produce",
  白灵菇: "produce",
  白玉米: "produce",
  白玉菇: "produce",
  白瓜子: "other",
  白甘蓝: "produce",
  白甘藍: "produce",
  白番茄: "produce",
  白皮茄: "produce",
  白皮蒜: "produce",
  白石榴: "fruit",
  白米: "other",
  白糖: "other",
  白糖罂荔枝: "fruit",
  白糖罌荔枝: "fruit",
  白肉桃: "fruit",
  白肉火龍果: "fruit",
  白胡椒: "other",
  白腰豆: "other",
  白芝麻: "other",
  白花菜: "produce",
  白芷: "other",
  白芸豆: "other",
  白苏: "produce",
  白苦瓜: "produce",
  白茄子: "produce",
  白草莓: "fruit",
  白莧菜: "produce",
  白菜: "produce",
  白菜豬肉餡: "meat",
  白菜豬肉馅: "meat",
  白薯: "produce",
  白蘆筍: "produce",
  白蘇: "produce",
  白蘑: "produce",
  白蘑菇: "produce",
  白蘭瓜: "fruit",
  白蘿蔔: "produce",
  白蛤: "seafood",
  白蝦: "seafood",
  白西柚: "fruit",
  白豆蔻: "other",
  白豆角: "produce",
  白醋: "other",
  白醬油: "other",
  白金針菇: "produce",
  白金针菇: "produce",
  白靈菇: "produce",
  白飯魚: "seafood",
  白饭魚: "seafood",
  白鯧: "seafood",
  白鰱: "seafood",
  白鱔: "seafood",
  白鳝: "seafood",
  白麵: "other",
  白麵包: "other",
  白麻油: "other",
  白黃瓜: "produce",
  白黄瓜: "produce",
  百里香: "produce",
  百頁豆腐: "other",
  百香果: "fruit",
  皇冠梨: "fruit",
  皇帝蕉: "fruit",
  皮皮蝦: "seafood",
  皮蛋: "other",
  皱葉甘蓝: "produce",
  皺葉甘藍: "produce",
  益生菌酸奶: "dairy",
  目魚: "seafood",
  眉豆: "other",
  真姬菇: "produce",
  真鱈魚: "seafood",
  眼肉牛排: "meat",
  短圆茄: "produce",
  短圓茄: "produce",
  短豆芽: "produce",
  短豆角: "produce",
  短黃瓜: "produce",
  短黄瓜: "produce",
  矮瓜: "produce",
  矮茄子: "produce",
  矮豆: "produce",
  石斑: "seafood",
  石斑魚: "seafood",
  石榴: "fruit",
  石榴汁: "other",
  石榴籽: "fruit",
  石硖龍眼: "fruit",
  石硤龍眼: "fruit",
  石花菜: "produce",
  石蟹: "seafood",
  砀山梨: "fruit",
  砂仁: "other",
  砂糖: "other",
  砂糖橘: "fruit",
  砲管: "seafood",
  硬果番茄: "produce",
  硬桃: "fruit",
  硬番茄: "produce",
  硬糖: "other",
  硬質奶酪: "dairy",
  硬质奶酪: "dairy",
  碎奶酪: "dairy",
  碎肉: "meat",
  碧根果: "other",
  碭山梨: "fruit",
  碳酸飲料: "other",
  碳酸饮料: "other",
  磅蛋糕: "other",
  神秘果: "fruit",
  神菇: "produce",
  福壽螺: "seafood",
  福寿螺: "seafood",
  福山萵苣: "produce",
  秀珍菇: "produce",
  秈米: "other",
  秋刀魚: "seafood",
  秋月梨: "fruit",
  秋菇: "produce",
  秋葵: "produce",
  秦冠蘋果: "fruit",
  秦椒: "produce",
  秧黃瓜: "produce",
  秧黄瓜: "produce",
  稀刺黃瓜: "produce",
  稀刺黄瓜: "produce",
  稀奶油: "dairy",
  稍瓜: "produce",
  稻草菇: "produce",
  穀物蛋: "dairy",
  空心菜: "produce",
  空心菜芽: "produce",
  突尼斯軟籽石榴: "fruit",
  突尼斯软籽石榴: "fruit",
  章姬草莓: "fruit",
  章魚: "seafood",
  章魚足: "seafood",
  章魚頭: "seafood",
  童子雞: "meat",
  竹筍: "produce",
  竹節蝦: "seafood",
  竹节蝦: "seafood",
  竹荪: "produce",
  竹蓀: "produce",
  竹蛏: "seafood",
  竹蟶: "seafood",
  笨雞蛋: "dairy",
  筍乾: "other",
  筍尖: "produce",
  筍片: "produce",
  筍瓜: "produce",
  筍衣: "produce",
  筒骨: "meat",
  節瓜: "produce",
  米浆: "other",
  米漿: "other",
  米粉: "other",
  米線: "other",
  米线: "other",
  米苔目: "other",
  米蕉: "fruit",
  米酒: "other",
  米醋: "other",
  籼米: "other",
  粄條: "other",
  粉果番茄: "produce",
  粉條: "other",
  粉殼雞蛋: "dairy",
  粉番茄: "produce",
  粉絲: "other",
  粉蕉: "fruit",
  粗米粉: "other",
  粗茄子: "produce",
  粗豆芽: "produce",
  粘糕: "other",
  粳米: "other",
  粿條: "other",
  糖: "other",
  糖果: "other",
  糖浆: "other",
  糖漿: "other",
  糖炒栗子: "other",
  糖粉: "other",
  糙米: "other",
  糯玉米: "produce",
  糯米: "other",
  糯米椒: "produce",
  糯米糍荔枝: "fruit",
  糯米餈荔枝: "fruit",
  紅加仑: "fruit",
  紅加侖: "fruit",
  紅包菜: "produce",
  紅咖喱: "other",
  紅土豆: "produce",
  紅圣女果: "produce",
  紅地球葡萄: "fruit",
  紅地瓜: "produce",
  紅富士: "fruit",
  紅富士蘋果: "fruit",
  紅将军蘋果: "fruit",
  紅將軍蘋果: "fruit",
  紅布林: "fruit",
  紅心柚: "fruit",
  紅心火龍果: "fruit",
  白柚: "fruit",
  紅柚: "fruit",
  西施柚: "fruit",
  白龍果: "fruit",
  香丁: "fruit",
  牛奶鳳梨: "fruit",
  蜜瓜: "fruit",
  美濃瓜: "fruit",
  玉荷包: "fruit",
  紅心猕猴桃: "fruit",
  紅心獼猴桃: "fruit",
  紅心芭樂: "fruit",
  紅心薯: "produce",
  紅心蘿蔔: "produce",
  紅提: "fruit",
  紅木瓜: "fruit",
  紅李: "fruit",
  紅杏: "fruit",
  紅杨梅: "fruit",
  紅柿子: "produce",
  紅树莓: "fruit",
  紅條: "seafood",
  紅梨: "fruit",
  紅棗: "other",
  紅椒: "produce",
  紅楊梅: "fruit",
  紅樹莓: "fruit",
  紅橘: "fruit",
  紅橙: "fruit",
  紅櫻桃: "fruit",
  紅殼雞蛋: "dairy",
  紅毛丹: "fruit",
  紅洋蔥: "produce",
  紅灯櫻桃: "fruit",
  紅燈櫻桃: "fruit",
  紅燒肉: "other",
  紅玛瑙: "fruit",
  紅瑪瑙: "fruit",
  紅瓤西瓜: "fruit",
  紅甘蓝: "produce",
  紅甘藍: "produce",
  紅皮蘿蔔: "produce",
  紅皮香蕉: "fruit",
  紅石斑: "seafood",
  紅石榴: "fruit",
  紅秋葵: "produce",
  紅米: "other",
  紅糖: "other",
  紅聖女果: "fruit",
  紅肉李: "fruit",
  紅肉火龍果: "fruit",
  紅腰豆: "other",
  紅花椒: "other",
  紅芸豆: "other",
  紅苋菜: "produce",
  紅茄子: "produce",
  紅茶: "other",
  紅莧菜: "produce",
  紅菇: "produce",
  紅菜苔: "produce",
  紅菜薹: "produce",
  紅菜頭: "produce",
  紅菱: "produce",
  紅葉生菜: "produce",
  紅蔥頭: "produce",
  紅酒: "other", // red wine (cooking)
  紅酒醋: "other", // red wine vinegar
  紅薯: "produce",
  紅薯粉: "other",
  紅蘿蔔: "produce",
  紅蛇果: "fruit",
  紅蝦: "seafood",
  紅蟳: "seafood",
  紅蟹: "seafood",
  紅西柚: "fruit",
  紅豆: "other",
  紅豆芽: "produce",
  紅豆角: "produce",
  紅象牙芒: "fruit",
  紅辣椒: "produce",
  紅顏草莓: "fruit",
  紅颜草莓: "fruit",
  紅香椿: "produce",
  紅鯛魚: "seafood",
  紅鳳菜: "produce",
  紅龍果: "fruit",
  純牛奶: "dairy",
  紙杯蛋糕: "other",
  素火腿: "other",
  素肉: "other",
  素蠔油: "other",
  素雞: "other",
  素面: "other",
  素鴨: "other",
  素麵: "other",
  紫圆茄: "produce",
  紫圓茄: "produce",
  紫土豆: "produce",
  紫圣女果: "produce",
  紫地瓜: "produce",
  紫山药: "produce",
  紫山藥: "produce",
  紫心紅薯: "produce",
  紫心薯: "produce",
  紫椒: "produce",
  紫洋蔥: "produce",
  紫玉米: "produce",
  紫甘蓝: "produce",
  紫甘藍: "produce",
  紫番茄: "produce",
  紫皮蒜: "produce",
  紫米: "other",
  紫罗勒: "produce",
  紫羅勒: "produce",
  紫聖女果: "fruit",
  紫背天葵: "produce",
  紫花菜: "produce",
  紫苏: "produce",
  紫苏葉: "produce",
  紫苤蓝: "produce",
  紫苤藍: "produce",
  紫茄子: "produce",
  紫菜: "other",
  紫菜苔: "produce",
  紫菜薹: "produce",
  紫葉甘蓝: "produce",
  紫葉甘藍: "produce",
  紫葉生菜: "produce",
  紫薯: "produce",
  紫蘆筍: "produce",
  紫蘇: "produce",
  紫蘇葉: "produce",
  紫豆角: "produce",
  紫長茄: "produce",
  細米粉: "other",
  細茄子: "produce",
  細豆芽: "produce",
  細豆角: "produce",
  細香蔥: "produce",
  結球甘藍: "produce",
  結球萵苣: "produce",
  絞肉: "meat",
  絲瓜: "produce",
  絲瓜絡: "other",
  絲瓜络: "other",
  絲瓜花: "produce",
  絲瓜苗: "produce",
  綠咖喱: "other",
  綠哈密瓜: "fruit",
  綠圣女果: "produce",
  綠心猕猴桃: "fruit",
  綠心獼猴桃: "fruit",
  綠提: "fruit",
  綠甘蓝: "produce",
  綠甘藍: "produce",
  綠番茄: "produce",
  綠秋葵: "produce",
  綠聖女果: "fruit",
  綠花菜: "produce",
  綠苋菜: "produce",
  綠茄子: "produce",
  綠茶: "other",
  綠莧菜: "produce",
  綠葉甘蓝: "produce",
  綠葉甘藍: "produce",
  綠葉生菜: "produce",
  綠薄荷: "produce",
  綠蘆筍: "produce",
  綠豆: "other",
  綠豆粉絲: "other",
  綠豆芽: "produce",
  綠豆苗: "produce",
  綠香椿: "produce",
  綠黃瓜: "produce",
  綠黄瓜: "produce",
  網紋瓜: "fruit",
  綿白糖: "other",
  線椒: "produce",
  線茄: "produce",
  縊蟶: "seafood",
  纯牛奶: "dairy",
  纸杯蛋糕: "other",
  线椒: "produce",
  线茄: "produce",
  结球甘蓝: "produce",
  绞肉: "meat",
  绵白糖: "other",
  缢蛏: "seafood",
  罐装玉米: "other",
  罐裝玉米: "other",
  罐頭: "other",
  罐頭午餐肉: "other",
  罐頭梨: "other",
  罐頭橘子: "other",
  罐頭沙丁魚: "other",
  罐頭火腿: "other",
  罐頭牛肉: "other",
  罐頭玉米: "other",
  罐頭荔枝: "other",
  罐頭蘑菇: "other",
  罐頭豌豆: "other",
  罐頭豬肉: "other",
  罐頭金枪魚: "other",
  罐頭金槍魚: "other",
  罐頭雞肉: "other",
  罐頭鳳尾魚: "other",
  罐頭黃桃: "other",
  罐頭黄桃: "other",
  网纹瓜: "fruit",
  罗勒: "produce",
  罗氏蝦: "seafood",
  罗汉豆: "produce",
  罗非魚: "seafood",
  罗马生菜: "produce",
  罗马花菜: "produce",
  羅勒: "produce",
  羅氏蝦: "seafood",
  羅漢豆: "produce",
  羅非魚: "seafood",
  羅馬生菜: "produce",
  羅馬花菜: "produce",
  羊: "meat",
  羊尾: "meat",
  羊心: "meat",
  羊排: "meat",
  羊柳: "meat",
  羊栖菜: "produce",
  羊棒骨: "meat",
  羊棲菜: "produce",
  羊肉: "meat",
  羊肉串: "meat",
  羊肉冬瓜餡: "meat",
  羊肉冬瓜馅: "meat",
  羊肉卷: "meat",
  羊肉大蔥餡: "meat",
  羊肉大蔥馅: "meat",
  羊肉捲: "meat",
  羊肉片: "meat",
  羊肉胡蘿蔔餡: "meat",
  羊肉胡蘿蔔馅: "meat",
  羊肉餡: "meat",
  羊肉馅: "meat",
  羊肋排: "meat",
  羊肚: "meat",
  羊肚菌: "produce",
  羊肝: "meat",
  羊肠: "meat",
  羊肩肉: "meat",
  羊肺: "meat",
  羊肾: "meat",
  羊脑: "meat",
  羊脸肉: "meat",
  羊腎: "meat",
  羊腦: "meat",
  羊腩: "meat",
  羊腰: "meat",
  羊腰子: "meat",
  羊腰肉: "meat",
  羊腸: "meat",
  羊腿: "meat",
  羊腿肉: "meat",
  羊臉肉: "meat",
  羊舌: "meat",
  羊蝎子: "meat",
  羊蠍子: "meat",
  羊血: "meat",
  羊裡脊: "meat",
  羊角椒: "produce",
  羊角瓜: "fruit",
  羊角蜜: "fruit",
  羊角豆: "produce",
  羊角麵包: "other",
  羊蹄: "meat",
  羊里脊: "meat",
  羊頭肉: "meat",
  羊頸肉: "meat",
  羊颈肉: "meat",
  羊骨: "meat",
  美乃滋: "other",
  美人瓜: "produce",
  美味草菇: "produce",
  美国大杏仁: "other",
  美國大杏仁: "other",
  美早櫻桃: "fruit",
  美洲南瓜: "produce",
  美生菜: "produce",
  美白菇: "produce",
  美芹: "produce",
  羽衣甘蓝: "produce",
  羽衣甘藍: "produce",
  翠冠梨: "fruit",
  翼豆: "produce",
  老南瓜: "produce",
  老抽: "other",
  老椰子: "fruit",
  老玉米: "produce",
  老茄子: "produce",
  老蒜: "produce",
  老薑: "produce",
  老虎斑: "seafood",
  老豆腐: "other",
  老豆角: "produce",
  老酸奶: "dairy",
  老黃瓜: "produce",
  老黄瓜: "produce",
  耙耙柑: "fruit",
  聖代: "other",
  聖女果: "fruit",
  肉包子: "other",
  肉末: "meat",
  肉松麵包: "other",
  肉桂: "other",
  肉沫: "meat",
  肉眼牛排: "meat",
  肉糜: "meat",
  肉蟹: "seafood",
  肉豆蔻: "other",
  肉餡: "meat",
  肉馅: "meat",
  肉鬆麵包: "other",
  肉鯧: "seafood",
  肠粉: "other",
  肥羊: "meat",
  胖頭魚: "seafood",
  胡椒: "other",
  胡椒粉: "other",
  胡椒粒: "other",
  胡椒薄荷: "produce",
  胡荽: "produce",
  胡蔥: "produce",
  胡蘿蔔: "produce",
  胡蘿蔔丁: "produce",
  胡蘿蔔條: "produce",
  胡蘿蔔片: "produce",
  胡豆: "produce",
  能量飲料: "other",
  能量饮料: "other",
  脆柿: "fruit",
  脐橙: "fruit",
  脫脂奶: "dairy",
  脫脂奶粉: "other",
  脫脂牛奶: "dairy",
  脫脂酸奶: "dairy",
  脱脂奶: "dairy",
  脱脂奶粉: "other",
  脱脂牛奶: "dairy",
  脱脂酸奶: "dairy",
  腐乳: "other",
  腐竹: "other",
  腰果: "other",
  腰果奶: "other",
  腰豆: "other",
  腸粉: "other",
  膏蟹: "seafood",
  臍橙: "fruit",
  臘肉: "other",
  臘肠: "other",
  臘腸: "other",
  臭椿: "produce",
  臭菜根: "produce",
  臭豆腐: "other",
  臺灣木瓜: "fruit",
  臺灣青棗: "fruit",
  臺灣鳳梨: "fruit",
  舌鰨魚: "seafood",
  舌鳎魚: "seafood",
  舒化奶: "dairy",
  良姜: "other",
  良薑: "other",
  艾葉: "produce",
  艾蒿: "produce",
  艾門塔爾奶酪: "dairy",
  艾门塔尔奶酪: "dairy",
  节瓜: "produce",
  芋仔: "produce",
  芋梗: "produce",
  芋艿: "produce",
  芋頭: "produce",
  芒果: "fruit",
  芒果乾: "other",
  芙蓉豆腐: "other",
  芝士: "dairy",
  芝士蛋糕: "other",
  芝麻: "other",
  芝麻油: "other",
  芝麻菜: "produce",
  芝麻菜葉: "produce",
  芝麻醬: "other",
  芡实: "produce",
  芡實: "produce",
  芥兰花: "produce",
  芥兰菜: "produce",
  芥兰頭: "produce",
  芥末: "other",
  芥末油: "other",
  芥末醬: "other",
  芥菜: "produce",
  芥蓝: "produce",
  芥蓝苔: "produce",
  芥藍: "produce",
  芥藍苔: "produce",
  芥蘭: "produce",
  芥蘭花: "produce",
  芥蘭菜: "produce",
  芥蘭頭: "produce",
  芫荽: "produce",
  芬达: "other",
  芬達: "other",
  芭乐: "fruit",
  芭樂: "fruit",
  芭蕉: "fruit",
  花捲: "other",
  花枝: "seafood",
  花椒: "other",
  花椒油: "other",
  花椒粉: "other",
  花椒芽: "produce",
  花椰菜: "produce",
  花牛蘋果: "fruit",
  花玉米: "produce",
  花生: "other",
  花生仁: "other",
  花生奶: "other",
  花生油: "other",
  花生米: "other",
  花生芽: "produce",
  花生醬: "other",
  花甲: "seafood",
  花甲肉: "seafood",
  花苔: "produce",
  花茄子: "produce",
  花茶: "other",
  花菇: "produce",
  花菇乾: "other",
  花菇幹: "other",
  花菜: "produce",
  花菜芯: "produce",
  花菜葉: "produce",
  花蛤: "seafood",
  花螺: "seafood",
  花蟹: "seafood",
  花豆: "other",
  花豆角: "produce",
  花鰱: "seafood",
  花黃瓜: "produce",
  花黄瓜: "produce",
  芸豆: "produce",
  芹菜: "produce",
  芹菜心: "produce",
  芹菜根: "produce",
  芹菜葉: "produce",
  芹菜豬肉餡: "meat",
  芹菜豬肉馅: "meat",
  芽球甘蓝: "produce",
  芽球甘藍: "produce",
  芽苗菜: "produce",
  苋菜: "produce",
  苏打餅乾: "other",
  苜蓿: "produce",
  苜蓿芽: "produce",
  苜蓿菜: "produce",
  苣蕒菜: "produce",
  苤蓝: "produce",
  苤藍: "produce",
  苦瓜: "produce",
  苦瓜苗: "produce",
  苦苣: "produce",
  苦茶油: "other",
  苦菊: "produce",
  苦菜: "produce",
  茂谷柑: "fruit",
  茄子: "produce",
  茄子秧: "produce",
  茄子苗: "produce",
  茄果: "produce",
  茄瓜: "produce",
  茉莉花茶: "other",
  茨菰: "produce",
  茭瓜: "produce",
  茭白: "produce",
  茴香: "produce",
  茴香苗: "produce",
  茴香菜: "produce",
  茴香豬肉餡: "meat",
  茴香豬肉馅: "meat",
  茶: "other",
  茶树菇: "produce",
  茶樹菇: "produce",
  茶菇: "produce",
  茶葉蛋: "other",
  茶薪菇: "produce",
  茼蒿: "produce",
  荆芥: "produce",
  草果: "other",
  草莓: "fruit",
  草莓酸奶: "dairy",
  草莓醬: "other",
  草菇: "produce",
  草蝦: "seafood",
  草豆蔻: "other",
  草雞: "meat",
  草雞蛋: "dairy",
  草魚: "seafood",
  荊芥: "produce",
  荔枝: "fruit",
  荔枝乾: "other",
  荔枝幹: "other",
  荔浦芋: "produce",
  荞麥: "other",
  荞麥芽: "produce",
  荞麥麵: "other",
  荠菜: "produce",
  药芹: "produce",
  荷兰瓜: "produce",
  荷兰薯: "produce",
  荷兰豆: "produce",
  荷兰豆苗: "produce",
  荷兰豆角: "produce",
  荷兰黄瓜: "produce",
  荷葉: "produce",
  荷蘭瓜: "produce",
  荷蘭薯: "produce",
  荷蘭豆: "produce",
  荷蘭豆苗: "produce",
  荷蘭豆角: "produce",
  荷蘭黃瓜: "produce",
  荸荠: "produce",
  荸薺: "produce",
  莜麥菜: "produce",
  莧菜: "produce",
  莲子: "produce",
  莲花白: "produce",
  莲蓬: "produce",
  莲藕: "produce",
  莲藕节: "produce",
  莲雾: "fruit",
  莳蘿: "produce",
  莴筍: "produce",
  莴筍葉: "produce",
  莴苣: "produce",
  莽吉柿: "fruit",
  菊芋: "produce",
  菊苣: "produce",
  菜包子: "other",
  菜山药: "produce",
  菜山藥: "produce",
  菜心: "produce",
  菜椒: "produce",
  菜瓜: "produce",
  菜籽油: "other",
  菜花: "produce",
  菜苔: "produce",
  菜薹: "produce",
  菜豆苗: "produce",
  菠菜: "produce",
  菠蘿: "fruit",
  菠蘿包: "other",
  菠蘿片: "fruit",
  菠蘿罐頭: "other",
  菠蘿蜜: "fruit",
  華夫餅: "other",
  菱角: "produce",
  菲力牛排: "meat",
  菲达奶酪: "dairy",
  菲達奶酪: "dairy",
  萊姆: "fruit",
  萬里蟹: "seafood",
  萵筍: "produce",
  萵筍葉: "produce",
  萵苣: "produce",
  落苏: "produce",
  落葵: "produce",
  落蘇: "produce",
  葉牡丹: "produce",
  葡式蛋挞: "other",
  葡式蛋撻: "other",
  葡萄: "fruit",
  葡萄乾: "other",
  葡萄柚: "fruit",
  葡萄汁: "other",
  葫蘆: "produce",
  葫蘆瓜: "produce",
  葵花籽: "other",
  葵花籽油: "other",
  葵花苗: "produce",
  蒔蘿: "produce",
  蒙古口蘑: "produce",
  蒙自石榴: "fruit",
  蒜: "produce",
  蒜末: "produce",
  蒜泥: "produce",
  蒜片: "produce",
  蒜瓣: "produce",
  蒜米: "produce",
  蒜苔: "produce",
  蒜苗: "produce",
  蒜蓉: "produce",
  蒜蓉辣椒醬: "other",
  蒜薹: "produce",
  蒜頭: "produce",
  蒜黃: "produce",
  蒜黄: "produce",
  蒲公英: "produce",
  蒸煮麵: "other",
  蒸餃: "other",
  蒿子秆: "produce",
  蒿子稈: "produce",
  蓝纹奶酪: "dairy",
  蓝莓: "fruit",
  蓝莓乾: "other",
  蓝莓李: "fruit",
  蓝莓酸奶: "dairy",
  蓝莓醬: "other",
  蓝靛果: "fruit",
  蓝鳍金枪魚: "seafood",
  蓬蒿: "produce",
  蓮子: "produce",
  蓮花白: "produce",
  蓮蓬: "produce",
  蓮藕: "produce",
  蓮藕節: "produce",
  蓮霧: "fruit",
  蔓越莓: "fruit",
  蔓越莓乾: "other",
  蔓越莓幹: "other",
  蔥: "produce",
  蔥末: "produce",
  蔥段: "produce",
  蔥白: "produce",
  蔥絲: "produce",
  蔥綠: "produce",
  蔥花: "produce",
  蔥葉: "produce",
  蔬菜沙拉: "other",
  蔭油: "other",
  蔭油膏: "other",
  蕎麥: "other",
  蕎麥芽: "produce",
  蕎麥麵: "other",
  蕨菜: "produce",
  蕹菜: "produce",
  蕺菜: "produce",
  薄脆: "other",
  薄荷: "produce",
  薄荷糖: "other",
  薄荷葉: "produce",
  薄菇: "produce",
  薇菜: "produce",
  薏仁: "other",
  薏米: "other",
  薑: "produce",
  薑塊: "produce",
  薑末: "produce",
  薑片: "produce",
  薑絲: "produce",
  薑蓉: "produce",
  薑黃: "other",
  薑黄: "other",
  薯條: "other",
  薯片: "other",
  薹菜: "produce",
  薺菜: "produce",
  藍紋奶酪: "dairy",
  藍莓: "fruit",
  藍莓幹: "other",
  藍莓李: "fruit",
  藍莓酸奶: "dairy",
  藍莓醬: "other",
  藍靛果: "fruit",
  藍鰭金槍魚: "seafood",
  藕: "produce",
  藕尖: "produce",
  藕帶: "produce",
  藕節: "produce",
  藕节: "produce",
  藜麥: "other",
  藤椒: "other",
  藤椒油: "other",
  藤菜: "produce",
  藥芹: "produce",
  蘆筍: "produce",
  蘆筍尖: "produce",
  蘆荟: "produce",
  蘆蒿: "produce",
  蘆蒿杆: "produce",
  蘆薈: "produce",
  蘆蝦: "seafood",
  蘇打餅乾: "other",
  蘋果: "fruit",
  蘋果棗: "fruit",
  蘋果汁: "other",
  蘋果薄荷: "produce",
  蘋果醋: "other",
  蘋果醬: "other",
  蘑菇: "produce",
  蘑菇仔: "produce",
  蘭花菇: "produce",
  蘿蔓: "produce",
  蘿蔔: "produce",
  蘿蔔乾: "other",
  蘿蔔芽: "produce",
  蘿蔔苗: "produce",
  虎皮椒: "produce",
  虎蝦: "seafood",
  處女蟳: "seafood",
  虱目魚: "seafood",
  虱目魚丸: "other",
  虱目魚肚: "seafood",
  虹鱒魚: "seafood",
  蚌: "seafood",
  蚌肉: "seafood",
  蚕豆: "produce",
  蚕豆瓣: "produce",
  蚕豆苗: "produce",
  蛇果: "fruit",
  蛇瓜: "produce",
  蛇肉: "meat",
  蛇豆: "produce",
  蛇豆角: "produce",
  蛋: "dairy",
  蛋卷: "other",
  蛋挞: "other",
  蛋捲: "other",
  蛋撻: "other",
  蛋白: "dairy",
  蛋糕: "other",
  蛋黃: "dairy",
  蛋黃果: "fruit",
  蛋黃醬: "other",
  蛋黄: "dairy",
  蛋黄果: "fruit",
  蛋黄醬: "other",
  蛎黄: "seafood",
  蛏子: "seafood",
  蛤蜊: "seafood",
  蛤蜊肉: "seafood",
  蜂蜜: "other",
  蜂蜜芥末: "other",
  蜆子: "seafood",
  蜆: "seafood",
  蜆仔: "seafood",
  蚵仔: "seafood",
  東石蚵: "seafood",
  干貝: "seafood",
  孔雀蛤: "seafood",
  血蛤: "seafood",
  胎貝: "seafood",
  鳳螺: "seafood",
  蜜李: "fruit",
  蜜柑: "fruit",
  蜜柚: "fruit",
  蜜棗: "other",
  蜜橘: "fruit",
  蜜瓜南瓜: "produce",
  蜜菠蘿: "fruit",
  蝦: "seafood",
  蝦乾: "seafood",
  蝦仁: "seafood",
  蝦仁餃子: "other",
  蝦滑: "seafood",
  蝦片: "other",
  蝦球: "other",
  蝦皮: "seafood",
  蝦米: "seafood",
  蝦膏: "other",
  蝦蛄: "seafood",
  蝦醬: "other",
  蝦餃: "other",
  螃蟹: "seafood",
  螺旋花菜: "produce",
  螺絲椒: "produce",
  螺蛳: "seafood",
  螺螄: "seafood",
  蟠桃: "fruit",
  蟶子: "seafood",
  蟹: "seafood",
  蟹味菇: "produce",
  蟹柳: "other",
  蟹棒: "other",
  蟹肉: "seafood",
  蟹腿: "seafood",
  蟹醬: "other",
  蟹鉗: "seafood",
  蟹钳: "seafood",
  蟹黃: "seafood",
  蟹黄: "seafood",
  蠔: "seafood",
  蠔油: "other",
  蠔肉: "seafood",
  蠔菇: "produce",
  蠣黃: "seafood",
  蠣黄: "seafood",
  蠶豆: "produce",
  蠶豆瓣: "produce",
  蠶豆苗: "produce",
  血橙: "fruit",
  血皮菜: "produce",
  血蚶: "seafood",
  袋料香菇: "produce",
  裙帶菜: "produce",
  裡脊肉: "meat",
  褐蘑菇: "produce",
  西兰花: "produce",
  西兰花苗: "produce",
  西冷牛排: "meat",
  西施舌: "seafood",
  西柚: "fruit",
  西梅: "fruit",
  西洋南瓜: "produce",
  西洋菜: "produce",
  西瓜: "fruit",
  西瓜子: "other",
  西瓜汁: "other",
  西番莲: "fruit",
  西番蓮: "fruit",
  西紅柿: "produce",
  西紅柿苗: "produce",
  西芹: "produce",
  西葫蘆: "produce",
  西葫蘆瓜: "produce",
  西葫蘆苗: "produce",
  西蓝花: "produce",
  西藍花: "produce",
  西蘭花: "produce",
  西蘭花苗: "produce",
  覆盆子: "fruit",
  覆盆子醬: "other",
  角瓜: "produce",
  託曼尼榴蓮: "fruit",
  話梅: "other",
  變蛋: "other",
  话梅: "other",
  豆制品: "other",
  豆包: "other",
  豆奶: "other",
  豆子: "other",
  豆干: "other",
  豆沙包: "other",
  豆泡: "other",
  豆浆: "other",
  豆漿: "other",
  豆漿粉: "other",
  豆王: "produce",
  豆瓣菜: "produce",
  豆瓣醬: "other",
  豆皮: "other",
  豆腐: "other",
  豆腐乳: "other",
  豆腐乾: "other",
  豆腐條: "other",
  豆腐皮: "other",
  豆腐絲: "other",
  豆腐脑: "other",
  豆腐腦: "other",
  豆花: "other",
  豆芽: "produce",
  豆芽苗: "produce",
  豆芽菜: "produce",
  豆苗: "produce",
  豆苗菜: "produce",
  豆蔻: "other",
  豆製品: "other",
  豆角: "produce",
  豆角尖: "produce",
  豆角苗: "produce",
  豆豉: "other",
  豇豆: "produce",
  豇豆乾: "other",
  豇豆苗: "produce",
  豌豆: "produce",
  豌豆尖: "produce",
  豌豆芽: "produce",
  豌豆苔: "produce",
  豌豆苗: "produce",
  豌豆苗芽: "produce",
  豌豆荚: "produce",
  豌豆莢: "produce",
  豐水梨: "fruit",
  象拔蚌: "seafood",
  象牙芒: "fruit",
  象牙蚌: "seafood",
  豬: "meat",
  豬前腿: "meat",
  豬前腿肉: "meat",
  豬后腿: "meat",
  豬后腿肉: "meat",
  豬外脊: "meat",
  豬大排: "meat",
  豬大肠: "meat",
  豬大腸: "meat",
  豬小排: "meat",
  豬小肠: "meat",
  豬小腸: "meat",
  豬尾: "meat",
  豬尾巴: "meat",
  豬後腿: "meat",
  豬後腿肉: "meat",
  豬心: "meat",
  豬手: "meat",
  豬排: "meat",
  豬油: "other",
  豬牛肉餡: "meat",
  豬牛肉馅: "meat",
  豬皮: "meat",
  豬耳: "meat",
  豬耳朵: "meat",
  豬肉: "meat",
  豬肉丁: "meat",
  豬肉片: "meat",
  豬肉粒: "meat",
  豬肉絲: "meat",
  豬肉餃子: "other",
  豬肉餡: "meat",
  豬肉馅: "meat",
  豬肋排: "meat",
  豬肘: "meat",
  豬肚: "meat",
  豬肝: "meat",
  豬肠: "meat",
  豬肺: "meat",
  豬脑: "meat",
  豬脚: "meat",
  豬腦: "meat",
  豬腰: "meat",
  豬腰子: "meat",
  豬腳: "meat",
  豬腸: "meat",
  豬舌: "meat",
  豬血: "meat",
  豬裡脊: "meat",
  豬蹄: "meat",
  豬蹄膀: "meat",
  豬通脊: "meat",
  豬里脊: "meat",
  豬頭肉: "meat",
  豬頸肉: "meat",
  豬颈肉: "meat",
  豬骨: "meat",
  豬鼻孔: "produce",
  貓山王榴蓮: "fruit",
  貝果: "other",
  貝貝南瓜: "produce",
  貢桔: "fruit",
  貢菇: "produce",
  貴妃芒: "fruit",
  貴州辣椒: "produce",
  貽貝: "seafood",
  贛南臍橙: "fruit",
  贡桔: "fruit",
  贡菇: "produce",
  贵妃芒: "fruit",
  贵州辣椒: "produce",
  贻貝: "seafood",
  赣南脐橙: "fruit",
  赤嘴: "seafood",
  赤苏: "produce",
  赤蘇: "produce",
  赤豆: "other",
  赤貝: "seafood",
  赤鯮: "seafood",
  起司: "dairy",
  超高温灭菌奶: "dairy",
  超高溫滅菌奶: "dairy",
  越橘: "fruit",
  越瓜: "produce",
  車前草: "produce",
  車達奶酪: "dairy",
  車釐子: "fruit",
  軟果番茄: "produce",
  軟柿: "fruit",
  軟桃: "fruit",
  軟棗獼猴桃: "fruit",
  軟籽石榴: "fruit",
  軟糖: "other",
  軟絲: "seafood",
  軟質奶酪: "dairy",
  车前草: "produce",
  车达奶酪: "dairy",
  车釐子: "fruit",
  软果番茄: "produce",
  软柿: "fruit",
  软桃: "fruit",
  软棗猕猴桃: "fruit",
  软籽石榴: "fruit",
  软糖: "other",
  软质奶酪: "dairy",
  辣木葉: "produce",
  辣根: "other",
  辣椒: "produce",
  辣椒圈: "produce",
  辣椒段: "produce",
  辣椒油: "other",
  辣椒碎: "produce",
  辣椒秧: "produce",
  辣椒粉: "other",
  辣椒絲: "produce",
  辣椒苗: "produce",
  辣椒醬: "other",
  辣椒麵: "other",
  辣火鍋底料: "other",
  辣火锅底料: "other",
  辣白菜: "other",
  运动饮料: "other",
  进口牛油果: "fruit",
  迷你猕猴桃: "fruit",
  迷你獼猴桃: "fruit",
  迷你番茄: "fruit",
  迷你黃瓜: "produce",
  迷你黄瓜: "produce",
  迷迭香: "produce",
  透抽: "seafood",
  通心粉: "other",
  通菜: "produce",
  速凍餃子: "other",
  速溶咖啡: "other",
  速食麵: "other",
  進口牛油果: "fruit",
  運動飲料: "other",
  過溝菜蕨: "produce",
  過貓: "produce",
  郫县豆瓣: "other",
  郫縣豆瓣: "other",
  酪蛋白: "other",
  酸乳: "dairy",
  酸奶: "dairy",
  酸奶油: "dairy",
  酸奶飲品: "other",
  酸奶饮品: "other",
  酸棗: "fruit",
  酸浆: "fruit",
  酸漿: "fruit",
  酸菜: "other",
  酸黃瓜: "other",
  酸黄瓜: "other",
  醃菜: "other",
  醃蘿蔔: "other",
  醃黃瓜: "other",
  醃黄瓜: "other",
  醋: "other",
  醋栗: "fruit",
  醜八怪: "fruit",
  醜橘: "fruit",
  醬油: "other",
  醬油膏: "other",
  醬牛肉: "other",
  醬肉: "other",
  醬鴨: "other",
  释迦: "fruit",
  釋迦: "fruit",
  里脊肉: "meat",
  重奶油: "dairy",
  野兔: "meat",
  野山椒: "produce",
  野生蓝莓: "fruit",
  野生藍莓: "fruit",
  野苏: "produce",
  野茼蒿: "produce",
  野蘇: "produce",
  野豬肉: "meat",
  野雞: "meat",
  野香菇: "produce",
  野鴨: "meat",
  金帅蘋果: "fruit",
  金帥蘋果: "fruit",
  金杏: "fruit",
  金枕榴莲: "fruit",
  金枕榴蓮: "fruit",
  金果猕猴桃: "fruit",
  金果獼猴桃: "fruit",
  金枪魚: "seafood",
  金枪魚罐頭: "other",
  金桔: "fruit",
  金棗: "fruit",
  金槍魚: "seafood",
  金槍魚罐頭: "other",
  金橘: "fruit",
  金煌芒: "fruit",
  金煌芒果: "fruit",
  金瓜: "produce",
  金絲瓜: "produce",
  金線魚: "seafood",
  金线魚: "seafood",
  金針: "produce",
  金針菇: "produce",
  金針菜: "other",
  金鑽鳳梨: "fruit",
  金针: "produce",
  金针菇: "produce",
  金针菜: "other",
  金钻鳳梨: "fruit",
  金頂側耳: "produce",
  金頂蘑: "produce",
  金顶侧耳: "produce",
  金顶側耳: "produce",
  金顶蘑: "produce",
  金鯧: "seafood",
  釘螺: "seafood",
  銀杏: "fruit",
  銀耳: "produce",
  銀芽: "produce",
  銀針: "produce",
  銀针: "produce",
  銀魚: "seafood",
  銀鯧: "seafood",
  銀鱈魚: "seafood",
  錐螺: "seafood",
  錦荔枝: "produce",
  錦鯉: "seafood",
  鐵棍山藥: "produce",
  钉螺: "seafood",
  铁棍山药: "produce",
  锥螺: "seafood",
  锦荔枝: "produce",
  锦鯉: "seafood",
  長條茄: "produce",
  長竹蛏: "seafood",
  長竹蟶: "seafood",
  長茄子: "produce",
  長豆芽: "produce",
  長豆角: "produce",
  長黃瓜: "produce",
  長黄瓜: "produce",
  開心果: "other",
  關廟麵: "other",
  阳光玫瑰葡萄: "fruit",
  阿克苏蘋果: "fruit",
  阿克蘇蘋果: "fruit",
  阿根廷紅蝦: "seafood",
  陈醋: "other",
  陕西辣椒: "produce",
  陝西辣椒: "produce",
  陳醋: "other",
  鎮江醋: "other", // Zhenjiang vinegar
  鎮江香醋: "other", // Zhenjiang aromatic vinegar (Chinkiang)
  陽光玫瑰葡萄: "fruit",
  陽春麵: "other",
  隼人瓜: "produce",
  雙孢菇: "produce",
  雙孢蘑菇: "produce",
  雜色蛤: "seafood",
  雜菜: "produce",
  雞: "meat",
  雞全翅: "meat",
  雞大腿: "meat",
  雞小腿: "meat",
  雞屁股: "meat",
  雞心: "meat",
  雞心椒: "produce",
  雞枞菌: "produce",
  雞架: "meat",
  雞柳: "meat",
  雞樅菌: "produce",
  雞油菌: "produce",
  雞爪: "meat",
  雞精: "other",
  雞翅: "meat",
  雞翅中: "meat",
  雞翅尖: "meat",
  雞翅根: "meat",
  雞翅膀: "meat",
  雞肉: "meat",
  雞肉丁: "meat",
  雞肉片: "meat",
  雞肉絲: "meat",
  雞肉餡: "meat",
  雞肉馅: "meat",
  雞肝: "meat",
  雞肠: "meat",
  雞肫: "meat",
  雞胗: "meat",
  雞胸: "meat",
  雞胸肉: "meat",
  雞胸脯: "meat",
  雞脖: "meat",
  雞腸: "meat",
  雞腿: "meat",
  雞腿肉: "meat",
  雞腿菇: "produce",
  雞蛋: "dairy",
  雞蛋白: "dairy",
  雞蛋芒: "fruit",
  雞蛋茄: "produce",
  雞蛋豆腐: "other",
  雞蛋麵: "other",
  雞血: "meat",
  雞頭: "meat",
  雞骨架: "meat",
  雪梨: "fruit",
  雪灵菇: "produce",
  雪白菇: "produce",
  雪碧: "other",
  雪糕: "other",
  雪耳: "produce",
  雪花梨: "fruit",
  雪莲果: "produce",
  雪菜: "produce",
  雪蓮果: "produce",
  雪蟹: "seafood",
  雪裡蕻: "produce",
  雪里蕻: "produce",
  雪靈菇: "produce",
  雲南辣椒: "produce",
  雲吞: "other",
  雲盤蘑: "produce",
  雲耳: "produce",
  露地番茄: "produce",
  露地茄子: "produce",
  露地黃瓜: "produce",
  露地黄瓜: "produce",
  青冬瓜: "produce",
  青南瓜: "produce",
  青口: "seafood",
  青口貝: "seafood",
  青提: "fruit",
  青斑: "seafood",
  青木瓜: "fruit",
  青梅: "fruit",
  青梨: "fruit",
  青棗: "fruit",
  青椒: "produce",
  青椒秧: "produce",
  青椰子: "fruit",
  青橘: "fruit",
  青檸: "fruit",
  青檸檬: "fruit",
  青毛豆: "produce",
  青江菜: "produce",
  青瓜: "produce",
  青甘蓝: "produce",
  青甘藍: "produce",
  青皮茄: "produce",
  青石斑: "seafood",
  青稞: "other",
  青紫苏: "produce",
  青紫蘇: "produce",
  青腿蘑: "produce",
  青芒: "fruit",
  青芒果: "fruit",
  青花椒: "other",
  青花菜: "produce",
  青花魚: "seafood",
  青苤蓝: "produce",
  青苤藍: "produce",
  青苦瓜: "produce",
  青茄子: "produce",
  青菜: "produce",
  青蒜: "produce",
  青蔥: "produce", // scallion / spring onion
  青蘿蔔: "produce",
  青蚕豆: "produce",
  青蛤: "seafood",
  青蝦: "seafood",
  青蟹: "seafood",
  青蠶豆: "produce",
  青豆: "produce",
  青豌豆: "produce",
  青辣椒: "produce",
  青頭菌: "produce",
  青頭蘿蔔: "produce",
  青香蕉: "fruit",
  青魚: "seafood",
  青黃瓜: "produce",
  青黄瓜: "produce",
  青龍: "seafood",
  青龍椒: "produce",
  鞭筍: "produce",
  韓國年糕: "other",
  韓國泡菜: "other",
  韓國辣椒: "produce",
  韓國辣椒醬: "other", // gochujang
  韓式辣醬: "other", // gochujang
  韓式辣椒醬: "other", // gochujang
  苦椒醬: "other", // gochujang
  韩国年糕: "other",
  韩国泡菜: "other",
  韩国辣椒: "produce",
  韭菜: "produce",
  韭菜花: "produce",
  韭菜苔: "produce",
  韭菜薹: "produce",
  韭菜豬肉餡: "meat",
  韭菜豬肉馅: "meat",
  韭菜餃子: "other",
  韭蔥: "produce",
  韭黃: "produce",
  韭黄: "produce",
  響螺: "seafood",
  頂花黃瓜: "produce",
  順黃瓜: "produce",
  顶花黄瓜: "produce",
  顺黄瓜: "produce",
  風味酸奶: "dairy",
  风味酸奶: "dairy",
  飛蟹: "seafood",
  飛魚籽: "seafood",
  飞蟹: "seafood",
  飞魚籽: "seafood",
  食用油: "other",
  食用蘆荟: "produce",
  食用蘆薈: "produce",
  食鹽: "other",
  飲料: "other",
  餃子: "other",
  餅乾: "other",
  餐包: "other",
  餘甘子: "fruit",
  餛飩: "other",
  饅頭: "other",
  饮料: "other",
  馄饨: "other",
  馒頭: "other",
  香乾: "other",
  香印葡萄: "fruit",
  香吉士: "fruit",
  香梨: "fruit",
  香椿: "produce",
  香椿芽: "produce",
  香椿芽苗: "produce",
  香椿苗: "produce",
  香椿頭: "produce",
  香檬: "fruit",
  香水檸檬: "fruit",
  香水菠蘿: "fruit",
  香油: "other",
  香瓜: "fruit",
  香米: "other",
  香肠: "meat",
  香腸: "meat",
  香芋: "produce",
  香芹: "produce",
  香茅: "produce",
  香菇: "produce",
  香菇素蠔油: "other",
  香菜: "produce",
  香菜根: "produce",
  香菜梗: "produce",
  香葉: "other",
  香蔥: "produce",
  香蕉: "fruit",
  香蕉乾: "other",
  香蕉幹: "other",
  香蕉片: "other",
  香螺: "seafood",
  香醋: "other",
  香脂醋: "other", // balsamic vinegar
  馬卡龍: "other",
  馬奶葡萄: "fruit",
  馬肉: "meat",
  馬芬: "other",
  馬薩拉: "other",
  馬蘇裡拉: "dairy",
  馬蘇裡拉奶酪: "dairy",
  馬蘭頭: "produce",
  馬蹄: "produce",
  馬鈴薯: "produce",
  馬鬱蘭: "produce",
  馬鮫魚: "seafood",
  馬齒莧: "produce",
  駱駝肉: "meat",
  驢肉: "meat",
  马兰頭: "produce",
  马卡龍: "other",
  马奶葡萄: "fruit",
  马肉: "meat",
  马芬: "other",
  马苏里拉: "dairy",
  马苏里拉奶酪: "dairy",
  马萨拉: "other",
  马蹄: "produce",
  马郁兰: "produce",
  马铃薯: "produce",
  马鲛魚: "seafood",
  马齿苋: "produce",
  驴肉: "meat",
  骆驼肉: "meat",
  高筋麵粉: "other",
  高粱: "other",
  高良薑: "produce",
  高茄子: "produce",
  高达奶酪: "dairy",
  高達奶酪: "dairy",
  高鈣奶: "dairy",
  鬆餅: "other",
  鬼頭刀: "seafood",
  魔芋: "produce",
  魔芋豆腐: "other",
  魚: "seafood",
  魚丸: "other",
  魚卵: "seafood",
  魚塊: "seafood",
  魚子醬: "other",
  魚尾: "seafood",
  魚排: "seafood",
  魚柳: "seafood",
  魚泡: "seafood",
  魚片: "seafood",
  魚皮: "seafood",
  魚籽: "seafood",
  魚糜: "seafood",
  魚肉: "seafood",
  魚肚: "seafood",
  魚腥草: "produce",
  魚豆腐: "other",
  魚露: "other",
  魚頭: "seafood",
  魚餅: "other",
  魚骨: "seafood",
  魚鰾: "seafood",
  魚鱗草: "produce",
  魚鳔: "seafood",
  魚鳞草: "produce",
  魨魚: "seafood",
  魴魚: "seafood",
  魷魚: "seafood",
  魷魚乾: "seafood",
  魷魚圈: "seafood",
  魷魚筒: "seafood",
  魷魚身: "seafood",
  魷魚須: "seafood",
  魷魚须: "seafood",
  鮁魚: "seafood",
  鮑魚: "seafood",
  鮑魚仔: "seafood",
  鮟鱇魚: "seafood",
  鮭魚: "seafood",
  鮮奶: "dairy",
  鮮奶油: "dairy",
  鮮棗: "fruit",
  鮮蚕豆: "produce",
  鮮蝦: "seafood",
  鮮蠶豆: "produce",
  鮮香菇: "produce",
  鮮黃花菜: "produce",
  鮮黄花菜: "produce",
  鯉魚: "seafood",
  鯊魚: "seafood",
  鯖魚: "seafood",
  鯛魚: "seafood",
  鯧扁魚: "seafood",
  鯧魚: "seafood",
  鯰魚: "seafood",
  鯽魚: "seafood",
  鯿魚: "seafood",
  鰈魚: "seafood",
  鰨目魚: "seafood",
  鰩魚: "seafood",
  鰱魚: "seafood",
  鰻魚: "seafood",
  鱈魚: "seafood",
  鱈魚塊: "seafood",
  鱈魚片: "seafood",
  鱉: "seafood",
  鱒魚: "seafood",
  鱖魚: "seafood",
  鱖魚片: "seafood",
  鱧魚: "seafood",
  鱷梨: "fruit",
  鱸魚: "seafood",
  鱸魚片: "seafood",
  鲀魚: "seafood",
  鲂魚: "seafood",
  鲅魚: "seafood",
  鲽魚: "seafood",
  鳄梨: "fruit",
  鳊魚: "seafood",
  鳎目魚: "seafood",
  鳢魚: "seafood",
  鳥貝: "seafood",
  鳳尾菇: "produce",
  鳳梨: "fruit",
  鳳梨釋迦: "fruit",
  鴨: "meat",
  鴨屁股: "meat",
  鴨心: "meat",
  鴨掌: "meat",
  鴨架: "meat",
  鴨梨: "fruit",
  鴨翅: "meat",
  鴨肉: "meat",
  鴨肝: "meat",
  鴨肠: "meat",
  鴨胗: "meat",
  鴨胸: "meat",
  鴨胸肉: "meat",
  鴨腸: "meat",
  鴨腿: "meat",
  鴨腿肉: "meat",
  鴨舌: "meat",
  鴨蛋: "dairy",
  鴨血: "meat",
  鴨頭: "meat",
  鴨骨架: "meat",
  鴻喜菇: "produce",
  鴿子: "meat",
  鴿子肉: "meat",
  鴿子蛋: "dairy",
  鵝: "meat",
  鵝掌: "meat",
  鵝肉: "meat",
  鵝肝: "meat",
  鵝腿: "meat",
  鵝菜: "produce",
  鵝蛋: "dairy",
  鵝蛋茄: "produce",
  鵪鶉: "meat",
  鵪鶉肉: "meat",
  鵪鶉蛋: "dairy",
  鷹嘴豆: "other",
  鷹嘴豆罐頭: "other",
  鸟貝: "seafood",
  鸿喜菇: "produce",
  鹰嘴豆: "other",
  鹰嘴豆罐頭: "other",
  鹹菜: "other",
  鹹蛋: "other",
  鹹鴨蛋: "other",
  鹽: "other",
  鹽水毛豆: "other",
  鹽水鴨: "other",
  鹽菜: "other",
  鹿肉: "meat",
  鹿角菜: "produce",
  麒麟果: "fruit",
  麒麟瓜: "fruit",
  麥片: "other",
  麵包: "other",
  麵包蟹: "seafood",
  麵條: "other",
  麵條瓜: "produce",
  麵粉: "other",
  麻小: "seafood",
  麻椒: "other",
  麻油: "other",
  麻辣烫底料: "other",
  麻辣燙底料: "other",
  黃元帥: "fruit",
  黃咖喱: "other",
  黃哈密瓜: "fruit",
  黃土豆: "produce",
  黃地瓜: "produce",
  黃姑魚: "seafood",
  黃姜: "produce",
  黃心獼猴桃: "fruit",
  黃心薯: "produce",
  黃木瓜: "fruit",
  黃李: "fruit",
  黃枇杷: "fruit",
  黃桃: "fruit",
  黃桃罐頭: "other",
  黃桃酸奶: "dairy",
  黃椒: "produce",
  黃檸檬: "fruit",
  黃櫻桃: "fruit",
  黃油: "dairy",
  黃洋蔥: "produce",
  黃玉米: "produce",
  黃瑪瑙: "fruit",
  黃瓜: "produce",
  黃瓜丁: "produce",
  黃瓜條: "produce",
  黃瓜段: "produce",
  黃瓜片: "produce",
  黃瓜秧: "produce",
  黃瓜絲: "produce",
  黃瓜花: "produce",
  黃瓜苗: "produce",
  黃瓤西瓜: "fruit",
  黃甘藍: "produce",
  黃番茄: "produce",
  黃皮火龍果: "fruit",
  黃秋葵: "produce",
  黃米: "other",
  黃糖: "other",
  黃聖女: "fruit",
  黃聖女果: "fruit",
  黃肉桃: "fruit",
  黃肉火龍果: "fruit",
  黃花: "other",
  黃花菜: "produce",
  黃花魚: "seafood",
  黃蘑: "produce",
  黃豆: "other",
  黃豆芽: "produce",
  黃豆醬: "other",
  黃酒: "other",
  黃金針菇: "produce",
  黃金鳳梨: "fruit",
  黃雞魚: "seafood",
  黃香蕉: "fruit",
  黃魚: "seafood",
  黃鰭金槍魚: "seafood",
  黃鰭鮪: "seafood",
  黃鱔: "seafood",
  黃黃瓜: "produce",
  黄元帅: "fruit",
  黄咖喱: "other",
  黄哈密瓜: "fruit",
  黄土豆: "produce",
  黄圣女: "fruit",
  黄圣女果: "produce",
  黄姑魚: "seafood",
  黄心猕猴桃: "fruit",
  黄心薯: "produce",
  黄木瓜: "fruit",
  黄李: "fruit",
  黄枇杷: "fruit",
  黄桃: "fruit",
  黄桃罐頭: "other",
  黄桃酸奶: "dairy",
  黄椒: "produce",
  黄檸檬: "fruit",
  黄櫻桃: "fruit",
  黄油: "dairy",
  黄洋蔥: "produce",
  黄玉米: "produce",
  黄玛瑙: "fruit",
  黄瓜: "produce",
  黄瓜丁: "produce",
  黄瓜條: "produce",
  黄瓜段: "produce",
  黄瓜片: "produce",
  黄瓜秧: "produce",
  黄瓜絲: "produce",
  黄瓜花: "produce",
  黄瓜苗: "produce",
  黄瓤西瓜: "fruit",
  黄甘蓝: "produce",
  黄番茄: "produce",
  黄皮火龍果: "fruit",
  黄秋葵: "produce",
  黄米: "other",
  黄糖: "other",
  黄肉桃: "fruit",
  黄花: "other",
  黄花菜: "produce",
  黄花魚: "seafood",
  黄薑: "produce",
  黄蘑: "produce",
  黄豆: "other",
  黄豆芽: "produce",
  黄豆醬: "other",
  黄酒: "other",
  黄金针菇: "produce",
  黄金鳳梨: "fruit",
  黄香蕉: "fruit",
  黄魚: "seafood",
  黄鳍金枪魚: "seafood",
  黄鳝: "seafood",
  黄黄瓜: "produce",
  黑加仑: "fruit",
  黑加侖: "fruit",
  黑圣女果: "produce",
  黑布林: "fruit",
  黑提: "fruit",
  黑木耳: "produce",
  黑松露: "produce",
  黑树莓: "fruit",
  黑桑葚: "fruit",
  黑椒: "produce",
  黑樹莓: "fruit",
  黑櫻桃: "fruit",
  黑毛豆: "produce",
  黑炭杨梅: "fruit",
  黑炭楊梅: "fruit",
  黑珍珠蓮霧: "fruit",
  黑番茄: "produce",
  黑皮冬瓜: "produce",
  黑米: "other",
  黑美人西瓜: "fruit",
  黑聖女果: "fruit",
  黑胡椒: "other",
  黑芝麻: "other",
  黑茄子: "produce",
  黑莓: "fruit",
  黑莓醬: "other",
  黑葉荔枝: "fruit",
  黑豆: "other",
  黑豆干: "other",
  黑豆芽: "produce",
  黑豆醬油: "other",
  黑醋: "other",
  黑魚: "seafood",
  黑鮪魚: "seafood",
  黑鯧: "seafood",
  黑鱸魚: "seafood",
  黑麵包: "other",
  黑麻油: "other",
  鼠尾草: "produce",
  龍利魚: "seafood",
  龍口粉絲: "other",
  龍眼: "fruit",
  龍眼乾: "other",
  龍眼葡萄: "fruit",
  龍膽石斑: "seafood",
  龍蒿: "produce",
  龍蝦: "seafood",
  龍蝦尾: "seafood",
  龍蝦肉: "seafood",
  龍蝦鉗: "seafood",
  龍蝦钳: "seafood",
  龍须菜: "produce",
  龍须豆: "produce",
  龍鬚菜: "produce",
  龍鬚豆: "produce",
  龍鬚瓜: "produce",
  黃龍果: "fruit",
  栗子南瓜: "produce",
  皇宮菜: "produce",
  珍珠菜: "produce",
  刈菜: "produce",
  長年菜: "produce",
  水蓮: "produce",
  野蓮: "produce",
  高麗菜: "produce",
  紫高麗菜: "produce",
  高麗菜苗: "produce",
  芋莖: "produce",
  綠菱: "produce",
  美人腿: "produce",
  梅菜: "other",
};
